export interface AppointlyMainLink {
  user_id: number | string
  url: string
}

export interface GetMainLinksResponse {
  data:
    | AppointlyMainLink[]
    | {
        data: AppointlyMainLink[]
      }
    | null
  code: number
}
